var _rect, _path, _path2, _polyline, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    rx: 16,
    fill: "#fff1f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155 110 C155 78 192 60 217 85 C242 60 279 78 279 110 C279 160 217 198 217 198 C217 198 155 160 155 110Z",
    fill: "#f43f5e",
    opacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170 115 C170 90 198 76 217 95 C236 76 264 90 264 115 C264 155 217 185 217 185 C217 185 170 155 170 115Z",
    fill: "#f43f5e",
    opacity: 0.2
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "120,195 175,195 190,170 205,220 220,185 235,200 360,200",
    stroke: "#f43f5e",
    strokeWidth: 2.5,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.35
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 268,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#9f1239"
  }, "Kalp Sagligi")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartHealth);
export default __webpack_public_path__ + "static/media/heart-health.b7a4a419a9ebb766b3ce49e803d66d9a.svg";
export { ForwardRef as ReactComponent };